import React from 'react'

function FeatureTwo() {
    return (
        <>
            {/* Feature area Start */}
            <section className="rts-feature-area area-two rts-section-gapBottom">
                <div className="container">
                    <div className="section-inner">
                        <div className="row">
                            <div className="col-xl-6 col-lg-8">
                                <div className="left-side-content">
                                    <div className="section-title-area">
                                        <p
                                            className="sub-title wow fadeInUp"
                                            data-wow-delay=".2s"
                                            data-wow-duration="2s"
                                        >
                                            Features
                                        </p>
                                        <h2
                                            className="section-title wow fadeInUp"
                                            data-wow-delay=".5s"
                                            data-wow-duration="2s"
                                        >
                                            Innovative Features <br /> for Meme Lovers
                                        </h2>
                                    </div>
                                    <p
                                        className="desc wow fadeInUp"
                                        data-wow-delay=".8s"
                                        data-wow-duration="2s"
                                    >
                                        With Meme Coin, you can trade, share, and even support your
                                        favorite meme creators while becoming part of a global network
                                        of enthusiasts.
                                    </p>
                                    <div
                                        className="image-area wow scaleIn"
                                        data-wow-delay="1s"
                                        data-wow-duration="2s"
                                    >
                                        <img src="assets/images/feature/image-01.svg" alt="" />
                                        <img src="assets/images/feature/image-02.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="right-side-content">
                                    <ul
                                        className="wow fadeInUp"
                                        data-wow-delay=".8s"
                                        data-wow-duration="2s"
                                    >
                                        <li className="feature-wrapper">
                                            <div className="icon">
                                                <img
                                                    src="assets/images/feature/coin.svg"
                                                    width={70}
                                                    alt=""
                                                />
                                            </div>
                                            <h4 className="title"> Community-Drive</h4>
                                            <p className="desc mb--0">
                                                CoinCraze is fueled by memes, jokes, and the collective
                                                effort of its holders
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/feature/leaf.svg"
                                                width={52}
                                                alt=""
                                            />
                                        </li>
                                        <li className="feature-wrapper">
                                            <div className="icon">
                                                <img
                                                    src="assets/images/feature/coin.svg"
                                                    width={70}
                                                    alt=""
                                                />
                                            </div>
                                            <h4 className="title"> Rewarding Holders</h4>
                                            <p className="desc mb--0">
                                                Holders benefit from passive rewards through transaction
                                                reflections
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/feature/leaf.svg"
                                                width={52}
                                                alt=""
                                            />
                                        </li>
                                    </ul>
                                    <ul
                                        className="wow fadeInUp"
                                        data-wow-delay=".9s"
                                        data-wow-duration="2s"
                                    >
                                        <li className="feature-wrapper">
                                            <div className="icon">
                                                <img
                                                    src="assets/images/feature/coin.svg"
                                                    width={70}
                                                    alt=""
                                                />
                                            </div>
                                            <h4 className="title"> Fun and Memorable</h4>
                                            <p className="desc mb--0">
                                                Designed for enjoyment, meme coins bring lighthearted
                                                element to cryptocurrency
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/feature/leaf.svg"
                                                width={52}
                                                alt=""
                                            />
                                        </li>
                                        <li className="feature-wrapper">
                                            <div className="icon">
                                                <img
                                                    src="assets/images/feature/coin.svg"
                                                    width={70}
                                                    alt=""
                                                />
                                            </div>
                                            <h4 className="title"> Easy Accessibility</h4>
                                            <p className="desc mb--0">
                                                Available on top decentralized exchanges (DEX) and
                                                centralized exchanges
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/feature/leaf.svg"
                                                width={52}
                                                alt=""
                                            />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Feature area end */}
        </>

    )
}

export default FeatureTwo